import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "animate.css"
import "hover.css"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from "./http"
import NoMore from "./components/common/NoMore"
import config from "./config"


Vue.prototype.$ImgUrl = "https://gov.dangjian.link"

Vue.use(ElementUI)
Vue.component('no-more', NoMore)
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$imgUrl = config.imgUrl
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')